import React from "react";
import "./spinnerv2.css";
const Spinner = () => {
  return (
    <div className="fallback-spinner">
      <div className="loading component-loader">
        <div className="effect-11 effects"></div>
        <div className="effect-12 effects"></div>
        <div className="effect-13 effects"></div>
        {/* <h6 style={{fontSize:"13px"}}>Loading...</h6> */}
      </div>
    </div>
  );
};
export default Spinner;
